import { render, staticRenderFns } from "./StudentPasswordChange.vue?vue&type=template&id=13ff5b32&scoped=true"
import script from "./StudentPasswordChange.vue?vue&type=script&lang=js"
export * from "./StudentPasswordChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ff5b32",
  null
  
)

export default component.exports